// Templates agent widget schema — same structure as email-flow, new schema key for independent evolution
export { HtmlContentUpdateSchema, EmailFlowItemSchema, EmailFlowWidgetSchema, } from '../email-flow/email-flow.widget.schema';
export const TemplatesAgentWidgetSchemaKey = 'templates-agent-widget:v1';
export const TemplatesAgentWidgetSchemaKind = 'email';
